import { render, staticRenderFns } from "./report-business-detail.vue?vue&type=template&id=760bff7d&scoped=true&"
import script from "./report-business-detail.vue?vue&type=script&lang=ts&"
export * from "./report-business-detail.vue?vue&type=script&lang=ts&"
import style0 from "./report-business-detail.vue?vue&type=style&index=0&id=760bff7d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760bff7d",
  null
  
)

export default component.exports